
    <div class="pos-f-t w-lg left-auto pos-rlt z-index-10000">
      <cc-ng1-menu-top
        class="pos-fix dropdown-menu-right d-flex"
        [ngClass]="{ blurred: blurred, 'payment-failed': failedPayment }"
      ></cc-ng1-menu-top>
    </div>
    <router-outlet></router-outlet>
  